import React from 'react';
import { AlertCircleIcon, DollarSignIcon, ShoppingCartIcon, TrendingDownIcon } from 'lucide-react';
export function Challenge() {
  const barriers = [{
    icon: DollarSignIcon,
    title: 'Price',
    description: 'Healthier options often cost more than familiar alternatives',
    color: 'text-orange-600',
    bgColor: 'bg-orange-100'
  }, {
    icon: ShoppingCartIcon,
    title: 'Availability',
    description: 'Prescribed foods may not be in stock or accessible locally',
    color: 'text-blue-600',
    bgColor: 'bg-blue-100'
  }, {
    icon: TrendingDownIcon,
    title: 'Taste Preferences',
    description: "Patients won't stick to plans that don't match their preferences",
    color: 'text-red-600',
    bgColor: 'bg-red-100'
  }];
  return <section className="py-20 bg-white" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-600 px-4 py-2 rounded-full font-semibold mb-6" data-id="element-4">
            <AlertCircleIcon className="w-5 h-5" data-id="element-5" />
            The Challenge
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-6">
            Even the best food prescriptions fail <br data-id="element-7" /> if patients can't follow them
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-8">
            Price, availability, and taste preferences stand in the way of
            adherence — creating a massive gap between clinical nutrition guidance and
            real-world behavior
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-9">
          {barriers.map((barrier, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-gray-100" data-id="element-10">
              <div className={`w-16 h-16 rounded-2xl ${barrier.bgColor} ${barrier.color} flex items-center justify-center mb-6`} data-id="element-11">
                <barrier.icon className="w-8 h-8" data-id="element-12" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-13">
                {barrier.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-14">
                {barrier.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}